<template>
  <div id="app-details-view">
    <v-container fluid class="pa-5">
      <router-view :key="$route.path"/>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "AppDetailsView"
}
</script>

<style scoped lang="scss">
#app-details-view {
  padding-top: 64px;
  padding-left: 256px;
}
</style>
